export function getNoCacheHeader(): { [key: string]: string } {
  const headers = {};
  headers['Cache-Control'] = 'no-store, no-cache';
  return headers;
}
